import { render, staticRenderFns } from "./OkTextInput.vue?vue&type=template&id=90c9d2e0&"
import script from "./OkTextInput.vue?vue&type=script&lang=js&"
export * from "./OkTextInput.vue?vue&type=script&lang=js&"
import style0 from "./OkTextInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports